(() => {
  'use strict';
  const init = () => document.querySelectorAll('[data-n-access-sticky]').forEach((bar) => {
    if (bar.dataset.ready) return;
    const form = document.getElementById(bar.dataset.formId);
    const submit = form?.querySelector('[data-n-product-submit]');
    const button = bar.querySelector('[data-n-access-sticky-button]');
    const price = document.querySelector('[data-n-product-price]');
    const stickyPrice = bar.querySelector('[data-n-access-sticky-price]');
    if (!submit || !button) return;
    bar.dataset.ready = 'true';
    const mobile = window.matchMedia('(max-width:749px)');
    let frame = null;
    const sync = () => {
      bar.hidden = !mobile.matches || submit.getBoundingClientRect().bottom >= 0;
      button.disabled = submit.disabled;
      button.textContent = submit.textContent.trim();
      if (price && stickyPrice) stickyPrice.textContent = price.textContent;
    };
    const scheduleSync = () => {
      if (frame !== null) return;
      frame = window.requestAnimationFrame(() => {
        frame = null;
        sync();
      });
    };
    const observer = new MutationObserver(sync);
    observer.observe(submit, { attributes: true, childList: true, subtree: true, characterData: true });
    if (price) observer.observe(price, { childList: true, subtree: true, characterData: true });
    window.addEventListener('scroll', scheduleSync, { passive: true });
    window.addEventListener('resize', scheduleSync);
    mobile.addEventListener('change', sync);
    button.addEventListener('click', () => {
      if (!submit.disabled) submit.click();
    });
    sync();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
